<template>
  <div>
    <div class="wrapper">
      <NavbarDesktop
        v-if="isDesktop"
        :action="action"
        @onDiscardAction="emitClose"
        :currentMode="'inside'"
      />
      <!-- <h3>{{ $t('choose_table.title') }}</h3> -->
      <div class="tables-container" v-for="block in uiSections">
        <small>{{ block.name }}</small>
        <div class="table-blocks-container">
          <div class="table-blocks" v-for="(row, index) in block.rows" :key="index">
            <div
              v-for="t in row"
              :key="t.number"
              :class="tableClass(block.index, t)"
              @click="selectTable(block.index, t.internal_number)"
            >
              {{ t.number }}
              <span v-if="!t.free" class="check-amount">2</span>
            </div>
          </div>
        </div>

        <hr />
      </div>
    </div>
    <div class="confirm-button">
      <img src="/icons/btn-back.svg" @click="emitClose()" class="btn-back" />
    <small class="info" v-if="choice.section == -1">
      {{ $t('choose_table.small_hint') }}
    </small>
      <button
        class="btn btn-green"
        @click="emitSelection()"
        v-if="choice.section != -1"
      >{{ $t("choose_table.accept") }}</button>
    </div>
  </div>
</template>

<script>
import NavbarDesktop from "@/components/NavbarDesktop.vue";
export default {
  components: { NavbarDesktop },
  props: {
    sections: Array,
    orders: Array,
  },
  data() {
    return {
      action: { type: "createOrder" },
      tables: {},
      choice: {
        section: -1,
        table: 0,
      },
    };
  },
  methods: {
    emitSelection() {
      this.$emit("select", this.choice.section, this.choice.table);
    },
    buildCache() {
      this.orders.forEach((o) => {
        this.$set(this.tables, `${o.section}:${o.table}`, true);
      });
    },
    tableClass(section, t) {
      return {
        table: true,
        "table-occupied": !t.free,
        "selected-table":
          this.choice.table == t.number && this.choice.section === section,
      };
    },
    emitClose() {
      this.$emit("close");
    },
    selectTable(section, index) {
      this.choice.section = section;
      this.choice.table = index;
      this.$emit("selectTable", this.choice.section, this.choice.table);
    },
  },
  computed: {
    isDesktop() {
      return window.innerWidth > 768;
    },
    uiSections() {
      let blocks = [];

      this.sections.forEach((section, sIndex) => {
        let rows = [[]];

        for (let i = 0; i < Math.round(section.tables / 3); i++) {
          rows.push([]);
        }

        for (let t = 1; t <= section.tables; t++) {
          const rowIndex = Math.floor((t - 1) / 3);

          rows[rowIndex].push({
            internal_number: t,
            number: section.tables_list[t-1].name || t,
            free: !this.tables[`${sIndex}:${t}`],
          });
        }

        blocks.push({
          name: section.name,
          index: sIndex,
          rows,
        });
      });

      return blocks;
    },
  },
  mounted() {
    this.buildCache();
  },
  created() {
    if (this.$route.name == "move_action") this.action.type = "move";
  },
};
</script>

<style scoped>
.wrapper {
  padding-bottom: 25vh;
  z-index: 2;
  position: fixed;
  left: 0;
  top: 7%;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 3vh 0 14vh;
  background: #ededed;
  width: 100%;
  max-height: 95vh;
}
.wrapper::-webkit-scrollbar {
  width: 0;
}

.pt-15 {
  padding-top: 1.6vh;
}

.tables-container {
  display: block;
  position: relative;
  top: 0vh;
  margin: 0 auto;
}

h3 {
  font-size: 6.4vw;
  line-height: 0.8;
  margin-bottom: 0;
}

.confirm-button {
  background: #1d1d1d;
  bottom: 0;
  display: flex;
  justify-content: space-between;
  padding: 1.3vh 3.2vh 2.6vh;
  z-index: 5;
  width: 100%;
  position: fixed;
  left: 0;
}

.btn-back {
  background: #e2223b;
  color: white;
  width: 6.2vh;
  height: 6.2vh;
  border-radius: 5vh;
  border: none;
}

.btn-back img {
  margin: 0 -0.5vh auto;
  display: block;
}

.btn {
  height: auto;
  font-size: 2.3vh;
  width: 80%;
  line-height: normal;
  color: #1d1d1d !important;
  box-shadow: 0px 4px 1px rgba(0, 0, 0, 0.25);
  border-radius: 5vh;
}

.btn-green {
  background: #129b81;
  border: none;
  float: right;
  color: #ededed !important;
}

.btn-primary {
  background: #416293;
  border: none;
}

.table {
  position: relative;
  width: 26.7vw;
  height: 26.7vw;
  border-radius: 10px;
  border: 3px solid transparent;
  text-align: center;
  justify-content: center;
  display: flex;
  align-items: center;
  font-size: 3vh;
  line-height: 1.2;
  color: #ededed;
  margin: 0.8vh;
  font-weight: 550;
  background: #a4a3a1;
  vertical-align: middle;
}

.table-occupied {
  background-color: #416293;
  color: white;
}
.check-amount {
  background: #e2223b;
  font-size: 4vw;
  position: absolute;
  top: 0;
  right: 0;
  line-height: 1;
  padding: 0.3vh 1.6vw 0.4vh;
  border-radius: 50%;
}

hr {
  width: 100vw;
  margin: 3.7vh 0 0 -7vw;
}

.table-blocks {
  justify-content: flex-start;
  display: flex;
  margin: 0 auto;
  width: 90%;
}

.table.free {
  background: #a4a3a1;
  color: #ededed;
  border: 3px solid transparent;
}

.selected-table {
  border: 3px solid #129b81;
}

.tables-container small {
  color: #bcbcbc;
  font-size: 4.3vw;
  padding-top: 2.5vh;
  padding-left: 5.4vw;
  padding-bottom: 1vh;
  display: block;
}

.modal-container {
  z-index: 2;
  position: fixed;
  left: 0;
  top: 7%;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 3vh 0 14vh;
  background: #ededed;
  width: 100%;
  max-height: 95vh;
}

@media screen and (min-width: 768px) {
  .wrapper {
    margin: 0 auto;
    top: 0;
    height: 100vh;
    padding: 9.722vw 0 0;
  }
  .modal-container {
    width: 100%;
    right: 0;
    margin: 5.556vw auto 0;
    padding: 0;
    bottom: 0;
  }

  .tables-container {
    overflow-x: hidden;
    max-height: inherit;
    margin: 0 0.694vw -1px;
    width: 98.611vw;
  }
  .tables-container::-webkit-scrollbar {
    width: 0;
  }
  .tables-container h3 {
    display: none;
  }

  div.table-blocks-container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 1.042vw 1.25vw 0 1.17vw;
  }
  .table-blocks {
    width: 23.958vw;
    margin: 0;
    padding: 0;
  }
  .table-blocks:nth-child(4n) .table:nth-child(3n) {
    margin: 0;
  }

  .tables-container hr {
    width: 100vw;
    margin-left: 0;
  }
  .tables-container small {
    padding: 0 1.38889vw;
    font-size: 1.25vw;
    line-height: 1.458vw;
    margin-top: 1.389vw;
    color: #464646;
  }
  .table-blocks .table {
    justify-content: center;
    width: 6.9449vw;
    height: 6.9449vw;
    margin: 0 1.042vw 1.042vw 0;
    padding: 2.5vw 0;
    font-size: 1.66667vw;
    line-height: 1.944vw;
  }
  .confirm-button {
    display: none;
  }
  .check-amount {
    width: 1.458vw;
    height: 1.389vw;
    font-size: 0.972vw;
    line-height: 1.111vw;
    padding: 0.139vw 0.417vw;
  }
}
</style>
